/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get } from '@/services/api/client';
import { ApiResponse } from '@/services/api/types';
import { ModulePricingTier, VolumeDiscountRule } from '@/types/superadmin.types';

const BASE_URL = '/billing/catalog';

export const billingCatalogService = {
  async getTiers(moduleCode?: string): Promise<ModulePricingTier[]> {
    const params = moduleCode ? `?moduleCode=${moduleCode}` : '';
    const response = await get<ApiResponse<ModulePricingTier[]>>(`${BASE_URL}/tiers${params}`);
    return response.data;
  },

  async getDiscounts(): Promise<VolumeDiscountRule[]> {
    const response = await get<ApiResponse<VolumeDiscountRule[]>>(`${BASE_URL}/discounts`);
    return response.data;
  },
};
